import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-balance',
    templateUrl: './balance.component.html',
    styleUrls: ['./balance.component.scss'],
    standalone: false
})
export class BalanceComponent implements OnInit {

  @Input() heading:any;
  @Input() amount:any;
  @Input() sign:any = '$'

  constructor() { }

  ngOnInit(): void {
  }

}
